(function ($) {


    $(document).ready(function () {
        if($('.img-scroll-slider').length>0) {
            setTimeout(function () {
                $(".img-scroll-slider .row-wrap").css({"opacity":"1"});
            },500);

            $('.img-scroll-slider .row-wrap').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: false,
                cssEase: 'ease',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 1,
                            adaptiveHeight: true,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            draggable: true,
                            adaptiveHeight: true,
                        }
                    }
                ]
            });
        }
    });
    $(window).on("load", function() {
        $(window).on("orientationchange", function() {
            setTimeout(function () {
                if($('.img-scroll-slider').length>0) {
                    $('.img-scroll-slider .row-wrap').slick({
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 1,
                                    draggable: true,
                                    adaptiveHeight: true,
                                }
                            }
                        ]
                    });  
                }
            },300);
          });
      });

 


})(jQuery);